import { Link } from "react-router-dom";
import { site } from "@/data/site";

export default function NotFound() {
  return (
    <div className="relative flex flex-col items-center justify-center min-h-screen text-center px-4 bg-background-50">
      <span className="font-heading text-[8rem] md:text-[12rem] font-semibold text-primary-100 leading-none select-none pointer-events-none">
        404
      </span>
      <div className="relative z-10 -mt-10 md:-mt-16">
        <h1 className="font-heading text-2xl md:text-4xl font-semibold text-foreground-950">
          Diese Seite wurde nicht gefunden
        </h1>
        <p className="mt-4 max-w-md mx-auto font-body text-base text-foreground-600">
          Vielleicht hat sich der Rasen verändert. Kehren Sie einfach zurück zur Startseite – oder
          rufen Sie uns direkt an.
        </p>
        <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-3">
          <Link
            to="/"
            className="inline-flex items-center gap-2 rounded-md bg-primary-500 hover:bg-primary-600 text-background-50 font-label font-semibold text-base px-6 py-3.5 transition-colors whitespace-nowrap cursor-pointer"
          >
            <i className="ri-home-4-line text-lg" />
            Zur Startseite
          </Link>
          <a
            href={site.phoneHref}
            className="inline-flex items-center gap-2 rounded-md border border-background-300 text-foreground-800 hover:bg-background-100 font-label font-semibold text-base px-6 py-3.5 transition-colors whitespace-nowrap cursor-pointer"
          >
            <i className="ri-phone-fill text-lg" />
            {site.phoneDisplay}
          </a>
        </div>
      </div>
    </div>
  );
}